import { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { colors } from '@anyroad/theme';
import { JoinWaitlistModal } from './JoinWaitlistModal';
import { WaitlistSuccessModal } from './SuccessModal';
import {
  Container,
  Text,
  NoAvailability,
  LinkText,
  WaitlistText,
} from './styles';

type JoinWaitlistProps = {
  experienceId: number;
  noAvailability: boolean;
  userId: number;
  soldOutLinkText: string;
  brandColor: string;
  isoTime: boolean;
};

export const JoinWaitlist = ({
  experienceId,
  noAvailability,
  userId,
  soldOutLinkText,
  brandColor,
  isoTime,
}: JoinWaitlistProps) => {
  const intl = useIntl();
  const [open, setOpen] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);

  const handleSuccessModal = () => {
    setSuccessModal(true);
  };

  return (
    <Container>
      <WaitlistSuccessModal
        isOpen={successModal}
        onClose={() => setSuccessModal(false)}
      />
      <JoinWaitlistModal
        experienceId={experienceId}
        isOpen={open}
        onClose={() => setOpen(false)}
        showSuccessModal={() => handleSuccessModal()}
        userId={userId}
        brandColor={brandColor}
        isoTime={isoTime}
      />
      <div>
        {noAvailability ? (
          <NoAvailability>
            <Text>
              {intl.formatMessage({
                defaultMessage:
                  'Sorry, we currently do not have any availability',
                description:
                  'Message displayed when a tour or experience has no available booking slots',
              })}
            </Text>
            <LinkText
              color={brandColor}
              className="brand-color"
              fontSize="18px"
              onClick={() => setOpen(true)}
            >
              {soldOutLinkText ||
                intl.formatMessage({
                  defaultMessage: 'Join the waitlist',
                  description:
                    'Link text to join the waitlist when tour is sold out',
                })}
            </LinkText>
          </NoAvailability>
        ) : (
          <WaitlistText data-testid="join-waitlist-msg">
            <FormattedMessage
              defaultMessage="If your preferred date and time is unavailable, <link>join the waitlist</link>."
              description="Informational text prompting users to join waitlist if their preferred time is not available"
              values={{
                link: (chunks) => (
                  <LinkText
                    color={colors.primary}
                    className="brand-color"
                    onClick={() => setOpen(true)}
                  >
                    {chunks}
                  </LinkText>
                ),
              }}
            />
          </WaitlistText>
        )}
      </div>
    </Container>
  );
};
